export default {
  PUSH_DEPARTMENT_FORMS: 'PUSH_DEPARTMENT_FORMS',
  RESET_DEPARTMENT_STATE: 'RESET_DEPARTMENT_STATE',
  SET_DEPARTMENT_IS_LOADING: 'SET_DEPARTMENT_IS_LOADING',
  SET_FORM_FOR: 'SET_FORM_FOR',
};
